import initData from '../initData';
import utils from "../index";

const workDate = initData.workDays;
const restDate = initData.restDays;

export default{
    startDate: "",
    repeatType: "",
    repeatCycle: 1,
    repeatInfo: "",
    endNumber: 0,
    endDate: "",
    getEndDate: function(info){
        this.initInfo(info)
        if(this.repeatType === "every_day"){
            this.repeatEveryDay();
        }else if(this.repeatType === "every_week"){
            this.repeatEveryWeek()
        }else if(this.repeatType === "work_day"){
            this.repeatWorkDay();
        }else if(this.repeatType === "every_month"){
            this.repeatEveryMonth();
        }else if(this.repeatType === "every_year"){
            this.repeatEveryYear();
        }else if(this.repeatType === "month_week"){
            this.repeatMonthWeek();
        }else if(this.repeatType === "lunar_year"){
            this.repeatLunarYear();
        }else if(this.repeatType === "i_b_h_s"){
            this.repeatIBHS();
        }else if(this.repeatType === "custom_day"){
            this.repeatCustomDay();
        }else if(this.repeatType === "custom_week"){
            this.repeatCustomWeek();
        }else if(this.repeatType === "custom_month"){
            this.repeatCustomMonth();
        }else if(this.repeatType === "custom_year"){
            this.repeatCustomYear();
        }
        return this.endDate;
    },
    initInfo: function(info){
        this.startDate = info.startDate;
        this.repeatType = info.repeatType;
        this.repeatCycle = info.repeatCycle;
        this.repeatInfo = info.repeatInfo;
        this.endNumber = parseInt(info.endNumber);

        this.endDate = "";
    },
    repeatEveryDay: function(){
        const startDate = Solar.fromDate(new Date(this.startDate));
        this.endDate = startDate.next(this.endNumber - 1).toYmd();

    },
    getEveryWeekCycle: function(repeatInfo, solarWeek, realCycle){
        const days = solarWeek.getDays();
        const itemYmd = days[repeatInfo - 1].toYmd();
        if(itemYmd >= this.startDate){
            realCycle.push(itemYmd)
        }
        if(realCycle.length < this.endNumber){
            solarWeek = solarWeek.next(1);
            return this.getEveryWeekCycle(repeatInfo, solarWeek, realCycle);
        }
    },
    repeatEveryWeek: function(){
        const solarWeek = SolarWeek.fromDate(new Date(this.startDate), 1);
        const repeatInfo = parseInt(this.repeatInfo);
        let realCycle = [];

        this.getEveryWeekCycle(repeatInfo, solarWeek, realCycle);
        this.endDate = realCycle[this.endNumber - 1];
    },
    getWorkDayCycle: function(solarWeek, realCycle, isContinue){
        const days = solarWeek.getDays();
        days.forEach((item)=>{
            const itemYmd = item.toYmd();
            if(isContinue && itemYmd >= this.startDate){
                let week = item.getWeek();
                if(week === 0){
                    week = 7;
                }
                if((week >= 6 && workDate.search(itemYmd) !== -1)
                    || (week <= 5 && restDate.search(itemYmd) === -1)){
                    realCycle.push(itemYmd);
                    if(realCycle.length >= this.endNumber){
                        isContinue = false;
                    }
                }
            }
        })
        if(isContinue){
            solarWeek = solarWeek.next(1);
            return this.getWorkDayCycle(solarWeek, realCycle, isContinue)
        }
    },
    repeatWorkDay: function(){
        const solarWeek = SolarWeek.fromDate(new Date(this.startDate), 1);
        let realCycle = [];
        console.log(solarWeek.getDays());

        this.getWorkDayCycle(solarWeek, realCycle, true);
        this.endDate = realCycle[this.endNumber - 1];
    },
    getEveryMonthCycle: function(repeatInfo, solarMonth, realCycle){
        const days = solarMonth.getDays();
        if(days.length >= repeatInfo){
            const itemYmd = days[repeatInfo - 1].toYmd();
            if(itemYmd >= this.startDate){
                realCycle.push(itemYmd);
            }
        }
        if(realCycle.length < this.endNumber){
            solarMonth = solarMonth.next(1)
            return this.checkMonthRealCycle(repeatInfo, solarMonth, realCycle)
        }
    },
    repeatEveryMonth: function(){
        const solarMonth = SolarMonth.fromDate(new Date(this.startDate));
        const repeatInfo = parseInt(this.repeatInfo);
        let realCycle = [];
        this.getEveryMonthCycle(repeatInfo, solarMonth, realCycle);
        this.endDate = realCycle[this.endNumber - 1];

    },
    getEveryYearCycle: function(year, month, day, realCycle){
        const days = SolarMonth.fromYm(year, month).getDays();
        if(days.length >= day){
            const ymd = days[day - 1].toYmd();
            if(ymd >= this.startDate){
                realCycle.push(ymd);
            }
        }
        if(realCycle.length < this.endNumber){
            year ++;
            return this.getEveryYearCycle(year, month, day, realCycle);
        }
    },
    repeatEveryYear: function(){
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");
        const year = new Date(this.startDate).getFullYear();
        const month = repeatInfo.month;
        const day = repeatInfo.day;
        let realCycle = [];

        this.getEveryYearCycle(year, month, day, realCycle);
        this.endDate = realCycle[this.endNumber - 1];

    },
    getMonthWeekCycle: function(weekIndex, week, targetCycleObj, realCycle, isContinue){
        const index = targetCycleObj.getIndex();
        const dayItems = targetCycleObj.getDays();

        if(index === weekIndex){

        }else if(weekIndex === 9){
            // 确认最后一周
            if(targetCycleObj.next(1).getIndex() > 1){
                return
            }
        }else{
            return
        }
        let month;
        if(index === 1){
            month = dayItems[6].getMonth();
        }else{
            month = dayItems[0].getMonth();
        }
        dayItems.forEach((dayItem)=>{
            if(month.getMonth() !== month){
                return
            }
            let dayWeek = dayItem.getWeek();
            if(dayWeek === 0){
                dayWeek = 7
            }
            if(dayWeek !== week){
                return
            }
            const itemYmd = dayItem.toYmd();
            if(isContinue && itemYmd >= this.startDate){
                realCycle.push(itemYmd);
                if(realCycle.length >= this.endNumber){
                    isContinue = false;
                }
            }
        })
        if(isContinue){
            targetCycleObj = targetCycleObj.next(1);
            this.getMonthWeekCycle(weekIndex, week, targetCycleObj, realCycle, true);
        }
    },
    repeatMonthWeek: function(){
        const solarWeek = SolarWeek.fromDate(new Date(this.startDate), 1);
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");
        const weekIndex = repeatInfo.weekIndex;
        const week = repeatInfo.week;
        let realCycle = [];

        this.getMonthWeekCycle(weekIndex, week, solarWeek, realCycle, true);
        this.endDate = realCycle[this.endNumber - 1];
    },

    repeatLunarYear: function(){
        let lunarDate = Lunar.fromDate(new Date(this.startDate));
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");
        const month = repeatInfo.month;
        const day = repeatInfo.day;
        let year = lunarDate.getYear() + (this.endNumber -1);
        lunarDate = Lunar.fromYmd(year, month, day);
        this.endDate = lunarDate.getSolar().toYmd();
    },
    repeatIBHS: function(){
        let realCycle = [];
        let isContinue = true;
        const startDate = Solar.fromDate(new Date(this.startDate));
        [0, 1, 2, 4, 7, 15].forEach((item,index)=>{
            const itemYmd = startDate.next(item).toYmd();
            if(isContinue && index+1 <= this.endNumber){
                realCycle.push(itemYmd);
            }else{
                isContinue = false
            }
        })

        if (isContinue) {
            let addDayNum = this.endNumber - 6;
            this.ednDate = startDate.next(15 * (addDayNum + 1)).toYmd()
        }else{
            this.ednDate = realCycle[realCycle.length - 1]
        }
    },
    repeatCustomDay: function(){
        const solarDate = Solar.fromDate(new Date(this.startDate));
        const endDate = solarDate.next(this.endNumber * (this.repeatCycle-1));
        this.endDate = endDate.toYmd();
    },
    getCustomWeekCycle: function(targetCycleObj, realCycle, isContinue){
        const dayItems = targetCycleObj.getDays();
        dayItems.forEach((dayItem)=>{
            const itemYmd = dayItem.toYmd();
            if(isContinue && itemYmd >= this.startDate){
                let week = dayItem.getWeek();
                if (week === 0){
                    week = 7
                }
                if(this.startInfo.indexOf(week) > -1){
                    realCycle.push(itemYmd);
                    if(realCycle.length >= this.endNumber){
                        isContinue = true;
                    }
                }
            }
        })
        if (isContinue){
            targetCycleObj = targetCycleObj.next(1);
            return this.getCustomWeekCycle(targetCycleObj, realCycle, isContinue);
        }
    },
    repeatCustomWeek: function(){
        const solarWeek = SolarWeek.fromDate(new Date(this.startDate), 1);
        const realCycle = [];
        this.getCustomWeekCycle(solarWeek, realCycle, true);
        this.endDate = realCycle[this.endNumber - 1];
    },
    getCustomMonthCycle: function(repeatInfo, solarMonth, realCycle, isContinue){
        const days = solarMonth.getDays();
        const lastDay = days[days.length-1].getDay();
        days.forEach((item)=>{
            const itemYmd = item.toYmd();
            if(isContinue && itemYmd >= this.listStartDate){
                const itemDay = item.getDay();
                if(repeatInfo.indexOf(itemDay) > -1 || (itemDay === lastDay && repeatInfo.indexOf("99") > -1)){
                    this.repeatCycle.push(itemYmd);
                    if(realCycle.length >= this.endNumber){
                        isContinue = false;
                    }
                }
            }
        })
        if(isContinue){
            solarMonth = solarMonth.next(1);
            return this.getCustomMonthCycle(repeatInfo, solarMonth, realCycle, isContinue);
        }
    },
    repeatCustomMonth: function(){
        const solarDate = Solar.fromDate(new Date(this.startDate));
        const solarMonth = SolarMonth.fromYm(solarDate.getYear(), solarDate.getMonth());
        const repeatInfo = this.repeatInfo.split(",");
        const realCycle = [];
        this.getCustomMonthCycle(repeatInfo, solarMonth, realCycle, true);
        this.endDate = realCycle[this.endNumber - 1];
    },
    getCustomYearCycle: function(year, month, day, realCycle){
        const days = SolarMonth.fromYm(year, month).getDays();
        if(days.length >= day){
            const itemYmd = days[day-1].toYmd();
            if(itemYmd >= this.startDate){
                realCycle.push(itemYmd);
            }
        }
        if(realCycle.length < this.endNumber){
            year ++;
            return this.getCustomYearCycle(year, month, day, realCycle);
        }
    },
    repeatCustomYear: function(){
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");
        const year = new Date(this.startDate).getFullYear();
        const month = repeatInfo;
        const day = repeatInfo;

        const realCycle = [];
        this.getCustomYearCycle(year, month, day, realCycle);
        this.endDate = realCycle[this.endNumber - 1];
    },
}